"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json_adapters_1 = require("./json-adapters");
exports.convertJsonForm = json_adapters_1.convertJsonForm;
exports.convertJsonResponse = json_adapters_1.convertJsonResponse;
exports.processResponseState = json_adapters_1.processResponseState;
exports.getAllElements = json_adapters_1.getAllElements;
exports.getAllPreviewElements = json_adapters_1.getAllPreviewElements;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/adapters/index.js
// module id = 1167
// module chunks = 0